import React, { createContext, useContext, useState, useCallback } from 'react';
import { API_ORIGIN } from '../config';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch notifications for all users (both regular users and approvers)
  const fetchNotifications = useCallback(async (userEmail, userRole = null) => {
    if (!userEmail) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${API_ORIGIN}/api/direct-orders/comments?userEmail=${encodeURIComponent(userEmail)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        
        // API returns {success: true, notifications: [...]} or {success: true, comments: [...]}
        if (data.success && (data.notifications || data.comments)) {
          setNotifications(data.notifications || data.comments);
        } else {
          setNotifications([]);
        }
      } else {
        setNotifications([]);
      }
    } catch (error) {
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    notifications,
    unreadCount: notifications.filter(n => !n.viewed).length,
    loading,
    fetchNotifications,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
